import { CURRENCY } from "@/shared/common/constants";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type {
  TextPropTypes,
  TTextTypes,
  TTextWeight
} from "@ab.uitools/ui-library/components/Text/types";
import { useMemo } from "react";

interface Props extends TextPropTypes {
  amount: number;
  isShow?: boolean;
  currency?: string;
  position?: string;
  floatType?: TTextTypes;
  leftIconProps?: ISVGIconProps;
  floatWeight?: TTextWeight;
}

export const Amount = (
  {
    amount,
    currency,
    isShow = true,
    type,
    floatType,
    size = "medium",
    position = "right",
    leftIconProps,
    className,
    weight = "bold",
    floatWeight = "regular",
  }: Props) => {
  const defaultFloatCount = currency == CURRENCY.AMD.label ? 1 : 2;
  const defaultFloatValue = currency === CURRENCY.AMD.label ? "0" : "00";
  const intAmount = amount ? Math.trunc(amount).toLocaleString() : "0";
  const floatAmount = useMemo(() => {
    return amount ? (amount % 1).toFixed(defaultFloatCount).substring(2) : defaultFloatValue;
  }, [amount, currency]);

  return (
    <div
      className={`flexbox align-items--center ${className} ${position === "right" && "justify-content--end"}`}>
      {leftIconProps?.Component ? (
        <leftIconProps.Component
          size={leftIconProps.size || "small"}
          className="mr-4"
          type={type || "primary"}
          {...leftIconProps}
        />
      ) : null}
      <Text type={type || "primary"} size={size} className="flexbox" weight={weight}>
        {isShow ? intAmount : "••••••••"}
      </Text>
      <Text
        size={size}
        className="float-part"
        weight={floatWeight}
        type={floatType || type || "tertiary"}
      >
        .{isShow ? floatAmount : "••"}
      </Text>
      <Text
        size={size}
        weight={floatWeight}
        className="ml-4 float-part"
        type={floatType || type || "tertiary"}
      >
        {CURRENCY[currency as string]?.symbol}
      </Text>
    </div>
  );
};
